module.exports = __webpack_public_path__ + "static/media/Asset 14@3x.fb24faed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 14@3x.png
// module id = 2418
// module chunks = 0